export const promoUPChannelComparator = (a, b) => {
    const aIsTopChannel = a.tags.includes('top-channels');
    const bIsTopChannel = b.tags.includes('top-channels');
    const aName = a.name || a.station_name;
    const bName = b.name || b.station_name;
    // Compare based on "top-channels" tag
    if (aIsTopChannel && !bIsTopChannel) {
        return -1;
    }
    else if (!aIsTopChannel && bIsTopChannel) {
        return 1;
    }
    // If both have "top-channels" tag or neither does, compare alphabetically by name
    if (!aIsTopChannel && !bIsTopChannel) {
        return aName.localeCompare(bName);
    }
    return 0; // a and b are considered equal in sorting
};
